export default function prepareApiPatchBody(parentElement) {
  const formInputs = parentElement.querySelectorAll('[data-prepare-api-patch-body]');
  const array = [];
  for (let i = 0; i < formInputs.length; i += 1) {
    const input = formInputs[i];
    array.push({
      op: 'replace',
      path: `/${input.getAttribute('name')}`,
      value: input.value
    });
  }
  return array;
}
